<div class="min-h-screen bg-gray-50/50">
    <div class="flex">
        <!-- Sidebar -->
        <app-sidebar></app-sidebar>

        <!-- Main Content Wrapper -->
        <div class="flex-1 lg:ms-[280px] flex flex-col min-w-0 min-h-screen">
            <!-- Header -->
            <header class="sticky top-0 z-50 bg-white shadow-sm">
                <app-header></app-header>
            </header>

            <!-- Page Content -->
            <main class="flex-1 p-4 sm:p-6 overflow-y-auto overflow-x-hidden">
                <router-outlet></router-outlet>
            </main>
        </div>
    </div>
</div>

@if (notificationSocket.toastVisible$ | async) {
  <div class="fixed bottom-6 end-6 z-[999999] flex items-start gap-3 bg-white border border-gray-200 rounded-2xl shadow-2xl px-5 py-4 w-[340px] toast-slide-up">

    <div class="h-10 w-10 rounded-xl bg-indigo-50 flex items-center justify-center shrink-0">
      <svg class="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 01-3.46 0"/>
      </svg>
    </div>

    <div class="flex-1 min-w-0">
      <p class="text-sm font-semibold text-[#0B0D5C]">
        {{ notificationSocket.toastTitle$ | async }}
      </p>
      <p class="text-xs text-gray-500 mt-0.5 line-clamp-2 leading-5">
        {{ notificationSocket.toastMessage$ | async }}
      </p>
    </div>

    <button
      (click)="notificationSocket.dismissToast()"
      class="text-gray-400 hover:text-gray-600 mt-0.5 shrink-0"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

  </div>
}